import { useLocales } from '@shared/locales'
import { Tag } from 'antd'

type Props = {
  isActive?: boolean
}

export const CampaignStatusTag = ({ isActive }: Props) => {
  const { t } = useLocales()

  return (
    <Tag color={isActive ? 'green' : 'default'}>
      {t(`lead_generation.${isActive ? 'active' : 'inactive'}`)}
    </Tag>
  )
}
